module.exports = __webpack_public_path__ + "static/media/CheckmarkBlack.7134a64c.svg";